import {Button, Checkbox, FormControlLabel, Stack, Typography} from '@mui/material';
import React from 'react';

import {Modal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {PrepareModalContent} from 'presentation/modules/myAppointments/ui/components/PrepareModalContent';

import {ExamOrientationsModalProps} from './types';
import {useExamOrientationsInfoStore} from '../../store/useExamOrientationsInfoStore';

const {keep} = translations['pt-br'].commons;
const {title, agreeCheckbox, headerTitle} =
	translations['pt-br'].privateFlow.bookingFlow.specialtyFlow.examOrientations;

export function ExamOrientationsModal({
	handleAgree,
	open,
	onToggleCheckbox,
	checked,
	onClose,
	dataTagIdInfo,
	dataTagIdButton,
}: ExamOrientationsModalProps) {
	const examOrientationsInfo = useExamOrientationsInfoStore(state => state.examOrientationInfo);

	return (
		<Modal.Root
			open={open}
			onClose={onClose}
			fullScreen={false}
			data-tag-id={dataTagIdInfo}
			fullWidth>
			<Modal.Header onClose={onClose} title={headerTitle} />
			<Modal.Content>
				<Stack spacing={2}>
					<Typography variant="h6" color="primary">
						{title}
					</Typography>
					<PrepareModalContent
						examNumber={examOrientationsInfo.code}
						examName={examOrientationsInfo.examName}
					/>
				</Stack>
				<FormControlLabel
					sx={{mt: 1}}
					control={<Checkbox checked={checked} onChange={onToggleCheckbox} />}
					label={agreeCheckbox}
				/>
			</Modal.Content>
			<Modal.Footer>
				<Button
					disabled={!checked}
					fullWidth
					variant="contained"
					size="large"
					onClick={() => handleAgree(examOrientationsInfo)}
					data-tag-id={dataTagIdButton}>
					{keep}
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
}
